export const TrackingReportsActionTypes = {
    API_RESPONSE_SUCCESS: '@@tracking-reports/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@tracking-reports/API_RESPONSE_ERROR',
    GET_DELAYED_FACILITIES_REQUEST: '@@tracking-reports/GET_DELAYED_FACILITIES_REQUEST',
    GET_DELAYED_FACILITIES_REPORT_REQUEST: '@@tracking-reports/GET_DELAYED_FACILITIES_REPORT_REQUEST',
    GET_SHIPMENT_TRACKING_RECORDS_REQUEST: '@@tracking-reports/GET_SHIPMENT_TRACKING_RECORDS_REQUEST',
    GET_SHIPMENT_TRACKING_REPORT_REQUEST: '@@tracking-reports/GET_SHIPMENT_TRACKING_REPORT_REQUEST',
    GET_AGGREGATED_DELAYED_SHIPMENTS_REQUEST: '@@tracking-reports/GET_AGGREGATED_DELAYED_SHIPMENTS_REQUEST',
    GET_AGGREGATED_DELAYED_SHIPMENTS_REPORT_REQUEST: '@@tracking-reports/GET_AGGREGATED_DELAYED_SHIPMENTS_REPORT_REQUEST',
    GET_ADDRESS_REPORT_REQUEST: '@@tracking-reports/GET_ADDRESS_REPORT_REQUEST',
    GET_ADDRESS_REPORT_FILE_REQUEST: '@@tracking-reports/GET_ADDRESS_REPORT_FILE_REQUEST',
    RESET_STATE: '@@tracking-reports/RESET_STATE',
};
